module.exports = __webpack_public_path__ + "static/media/contact_email-01.cc8adb71.png";